import { createSlice } from "@reduxjs/toolkit";

export const userLoginSlice = createSlice({
  name: "userStatus",
  initialState: {
    isUserLoggedIn: false,
  },
  reducers: {
    loginSuccess: (state, payload) => {
      state.isUserLoggedIn = true;
    },
    logOut: (state) => {
      state.isUserLoggedIn = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loginSuccess, logOut } = userLoginSlice.actions;

export default userLoginSlice.reducer;
